<template>
    <div>
        <v-breadcrumbs
            :items="[
                { text: 'Dashboard', to: { path: '/' } },
                { text: 'Riwayat Konsultasi' },
            ]"
            divider="|"
        ></v-breadcrumbs>

        <div class="font-weight-bold font-size-20 mt-3 mb-4">
            Riwayat Konsultasi
        </div>

        <consul-history-list />
    </div>
</template>

<script>
import ConsulHistoryList from "./components/ConsulHistoryList.vue";

export default {
    name: "consul-history",

    components: {
        ConsulHistoryList,
    },

    data() {
        return {
            loading: false,
        };
    },
};
</script>



// WEBPACK FOOTER //
// ConsulHistory.vue?28081500